/**
 * Карандаш в круге — «эту строку можно отредактировать».
 *
 * В макете залит брендовым зелёным (#2BB747), но цвет берётся из
 * `currentColor`: так иконка подчиняется теме и классу на месте вызова, как
 * и остальные иконки проекта. Круг под карандашом — тот же цвет с opacity
 * 0.2, поэтому подложка остаётся согласованной при любом цвете текста.
 */
export const EditPencilIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.2"
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="currentColor"
    />
    <path
      d="M13.9261 14.3015C14.1711 14.1104 14.3933 13.8882 14.8377 13.4438L20.378 7.90343C20.512 7.76949 20.4507 7.53878 20.2717 7.47669C19.6178 7.2498 18.767 6.82383 17.9713 6.02804C17.1755 5.23226 16.7495 4.38155 16.5226 3.72757C16.4605 3.54861 16.2298 3.4873 16.0959 3.62125L10.5555 9.16161C10.1111 9.60603 9.88888 9.82823 9.69778 10.0733C9.47235 10.3623 9.27908 10.675 9.12139 11.0059C8.98771 11.2864 8.88834 11.5845 8.68959 12.1807L8.43278 12.9512L8.02443 14.1762L7.64153 15.3249C7.54373 15.6183 7.6201 15.9418 7.8388 16.1605C8.0575 16.3792 8.38099 16.4556 8.67441 16.3578L9.82308 15.9749L11.0481 15.5665L11.8186 15.3097C12.4148 15.111 12.7129 15.0116 12.9934 14.8779C13.3243 14.7202 13.637 14.527 13.9261 14.3015Z"
      fill="currentColor"
    />
    <path
      d="M22.1126 6.16905C23.2951 4.98656 23.2951 3.06936 22.1126 1.88687C20.9301 0.704377 19.0129 0.704377 17.8305 1.88687L17.6523 2.06499C17.4805 2.23687 17.4026 2.47695 17.4455 2.7162C17.4725 2.8667 17.5226 3.08674 17.6137 3.3493C17.7959 3.87439 18.1399 4.56368 18.7879 5.21165C19.4358 5.85961 20.1251 6.20364 20.6502 6.38581C20.9128 6.4769 21.1328 6.52697 21.2833 6.55399C21.5226 6.59693 21.7626 6.51905 21.9345 6.34717L22.1126 6.16905Z"
      fill="currentColor"
    />
  </svg>
);
